export const CUSTOM_LINK = "CUSTOM_LINK";